import React from 'react';
import styled from 'styled-components';
import { Button, Icon } from 'antd';
import classNames from 'classnames';

const ButtonStyled = styled(Button)`
  &.ant-btn {
    border: 0;
    color: #2b9bff;
    font-size: 14px;
    background-color: initial;
    box-shadow: none;
    padding: 0 10px;
    &:hover, &:active, &:focus {
      background-color: initial;
    }
  }
  &.ant-btn[disabled] {
    filter: grayscale();
    &, &:hover, &:active, &:focus {
      background-color: initial;
    }
  }
`

export default function ActionButton(props) {
  const { iconClass, src, className, children, ...attrs } = props;
  return (
    <ButtonStyled
      className={classNames(className)}
      {...attrs}
    >
      {iconClass && <Icon component={() => <i className={iconClass} />} />}
      {src && <Icon component={() => <img src={src} />} />}
      {children}
    </ButtonStyled>
  );
}